import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import selectors from '../store/shared/selectors'
import ImpersonationBanner from '../components/ui/notifications/ImpersonationBanner'
import * as insTokenDuck from './unauthenticated/Onboarding/insTokenDuck'
import * as personalityAssessmentDuck from './authenticated/PersonalityAssessment/personalityAssessmentDuck'
import * as taskTypesDuck from '../store/shared/taskTypesDuck'
import { checkSSOLogin } from './unauthenticated/Login/loginDuck'

class AuthenticatedDataFetcher extends Component {
  static propTypes = {
    currentUser: PropTypes.any,
    getPersonalityAssessmentResultsForUser: PropTypes.func.isRequired,
    hasInsTokenResults: PropTypes.bool.isRequired,
    performRetrieveTasksTypes: PropTypes.func.isRequired,
    validateInsToken: PropTypes.func.isRequired,
  }

  componentWillMount() {
    if(this.props.currentUser && this.props.currentUser.info && this.props.currentUser.info.assessmentDone) {
      this.props.getPersonalityAssessmentResultsForUser()
    }
    this.props.performRetrieveTasksTypes()

    const shortName = window.location.hostname.split('.')[0]
    if(shortName !== 'app') this.props.checkSSOLogin({ shortName })

    // Get the insToken results. The insToken results data will be erased if we do hard reset,
    // that's why this network request is necessary.
    // Check if insToken results are already there, if yes then don't do network request.
    // If we do network request every time, then it causes university logo flickering issue.
    // If insToken results are updated, then have to make network request separately.
    if (this.props.currentUser && this.props.currentUser.insToken && !this.props.hasInsTokenResults) {
      this.props.validateInsToken(this.props.currentUser)
    }
  }

  render() {
    return <ImpersonationBanner user={this.props.currentUser} />
  }
}

const mapStateToProps = (state) => ({
  currentUser: selectors.getCurrentUser(state),
  hasInsTokenResults: insTokenDuck.hasInsTokenResults(state),
})

const mapDispatchToProps = dispatch => bindActionCreators({
  checkSSOLogin,
  getPersonalityAssessmentResultsForUser: personalityAssessmentDuck.getPersonalityAssessmentResultsForUser,
  performRetrieveTasksTypes: taskTypesDuck.performRetrieveTaskTypes,
  validateInsToken: insTokenDuck.performValidateInsToken,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(AuthenticatedDataFetcher)



// WEBPACK FOOTER //
// ./src/routes/AuthenticatedDataFetcher.js